// websocket.js
import { Notification } from "element-ui";

let socket = null;
let reconnectTimer = null;
let heartbeatTimer = null;
const timeout = 30000;
const reconnectDelay = 5000;

// AI消息处理相关变量
let type5MessageBuffer = '';
let isType5Complete = false; // 新增：标记type=5消息是否已完成

// 初始化WebSocket
const initWebSocket = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        Notification.error({ title: "错误", message: "未获取到用户Token" });
        return;
    }

    if (socket) closeWebSocket();

    const wsUrl = `ws://192.168.101.20:9999/outpatient/ws?token=${token}`;
    socket = new WebSocket(wsUrl);

    socket.onopen = () => {
        console.log('WebSocket连接已建立');
        startHeartbeat();
        window.dispatchEvent(new Event('websocket-open'));
    };

    socket.onmessage = (e) => {
        const message = JSON.parse(e.data);
        console.log('收到WebSocket消息:', message);
        resetHeartbeat();

        try {
            // 只处理type=5消息（AI回复消息）
            if (message.type === 5) {
                handleType5Message(message);
                return;
            }

            // 原有的其他消息处理逻辑
            if (message.type === 4) {
                Notification({
                    title: "安全警告",
                    message: "您的账号已在其他地方登录，您将被强制退出",
                    type: "error",
                    duration: 0,
                    showClose: false
                });

                setTimeout(() => {
                    localStorage.clear();
                    window.location.href = "#/login";
                }, 5000);
            }

            if (message.type === 3) {
                Notification({
                    title: "系统通知",
                    message: message.data || "您有一条新消息",
                    type: "warning",
                    duration: 4800
                });
            }

            window.dispatchEvent(new CustomEvent('websocket-message', { detail: message }));
        } catch (error) {
            console.error('消息处理失败:', error);
        }
    };

    socket.onclose = (e) => {
        reconnect();
        window.dispatchEvent(new Event('websocket-close'));
    };

    socket.onerror = (error) => {
        reconnect();
        window.dispatchEvent(new CustomEvent('websocket-error', { detail: error }));
    };
};

// 处理type=5消息 - 添加空字符串检测
const handleType5Message = (message) => {
    // 如果已经完成，不再处理新消息
    if (isType5Complete) {
        console.log('type=5消息已完成，忽略后续消息');
        return;
    }
    // 如果data为null或空字符串，标记为完成并分发
    if (message.data === '-1') {
        console.log('检测到空字符串，标记为type=5消息完成');
        isType5Complete = true;
        dispatchCompleteType5Message();
        return;
    }

    console.log('收到AI消息片段:', message.data);

    // 将当前片段的data拼接到缓冲区
    type5MessageBuffer += message.data;

    console.log('当前拼接后的完整内容:', type5MessageBuffer);

    // 分发片段更新事件
    window.dispatchEvent(new CustomEvent('websocket-ai-progress', {
        detail: {
            chunk: message.data,
            buffer: type5MessageBuffer,
            progress: type5MessageBuffer.length,
            timestamp: new Date().toISOString()
        }
    }));

    // 检查是否是消息结束的标志
    if (isMessageComplete(message)) {
        console.log('检测到消息自然结束，分发完整内容');
        isType5Complete = true;
        dispatchCompleteType5Message();
    }
};

// 判断消息是否完整
const isMessageComplete = (message) => {
    return (
        message.isEnd === true || // 后端明确的结束标志
        message.data.endsWith('。') || // 句号结尾
        message.data.endsWith('！') || // 感叹号结尾
        message.data.endsWith('？') || // 问号结尾
        message.data.includes('**处方建议**') || // 包含特定关键词
        message.data.includes('**诊断建议**') || // 包含特定关键词
        message.data.length < 3 // 很短的片段可能是结束
    );
};

// 分发完整的消息
const dispatchCompleteType5Message = () => {
    if (type5MessageBuffer) {
        const completeMessage = {
            type: 5,
            code: 200,
            msg: null,
            data: type5MessageBuffer,
            isComplete: true,
            isTimeout: false,
            timestamp: new Date().toISOString()
        };

        console.log('分发完整AI消息:', type5MessageBuffer);

        window.dispatchEvent(new CustomEvent('websocket-ai-complete', {
            detail: completeMessage
        }));

        // 重置状态
        resetType5Buffer();
    } else {
        console.log('缓冲区为空，不分发完成消息');
    }
};

// 重置缓冲区
const resetType5Buffer = () => {
    type5MessageBuffer = '';
    isType5Complete = false; // 重置完成状态
};

// 手动强制完成
const forceCompleteType5Message = () => {
    if (type5MessageBuffer) {
        isType5Complete = true;
        dispatchCompleteType5Message();
    }
};

// 获取当前缓冲区内容
const getCurrentAIBuffer = () => {
    return type5MessageBuffer;
};

// 检查type=5是否已完成
const isType5MessageComplete = () => {
    return isType5Complete;
};

// 启动心跳检测
const startHeartbeat = () => {
    let sendData = {
        type:'1',
        data:{}
    };
    heartbeatTimer = setInterval(() => {
        if (socket?.readyState === WebSocket.OPEN) {
            sendMessage(sendData);
        }
    }, timeout);
};

// 重置心跳检测
const resetHeartbeat = () => {
    clearInterval(heartbeatTimer);
    startHeartbeat();
};

// 重连机制
const reconnect = () => {
    if (reconnectTimer || !socket) return;

    reconnectTimer = setTimeout(() => {
        console.log('尝试重新连接...');
        initWebSocket();
        reconnectTimer = null;
    }, reconnectDelay);
};

// 发送消息
const sendMessage = (message) => {
    if (socket?.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
        return true;
    } else {
        console.error('WebSocket未连接，消息发送失败:', message);
        return false;
    }
};

// 关闭连接
const closeWebSocket = () => {
    if (socket) {
        socket.close();
        socket = null;
    }
    clearInterval(heartbeatTimer);
    clearTimeout(reconnectTimer);
    resetType5Buffer();
};

// 检查连接状态
const getConnectionStatus = () => {
    if (!socket) return 'disconnected';

    switch(socket.readyState) {
        case WebSocket.CONNECTING:
            return 'connecting';
        case WebSocket.OPEN:
            return 'connected';
        case WebSocket.CLOSING:
            return 'closing';
        case WebSocket.CLOSED:
            return 'disconnected';
        default:
            return 'unknown';
    }
};

// 确保所有方法都正确导出
export default {
    initWebSocket,
    sendMessage,
    closeWebSocket,
    getConnectionStatus,

    // AI消息相关方法
    resetType5Buffer,
    forceCompleteType5Message,
    getCurrentAIBuffer,
    isType5MessageComplete // 新增：检查是否完成
};